













































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import LaporanKegiatanIgd, {
  KegiatanIgdResponse,
  selKey
} from "@/services/LaporanKegiatanIgd";

@Component({})
export default class LaporanKegiatanIgdPage extends Vue {
  data: KegiatanIgdResponse | null = null;
  loading = false;
  saving = false;
  printing = false;

  tahun = moment().year();
  bulan = moment().month() + 1;

  draft: Record<string, number> = {};
  catatan: string | null = null;
  berubah = false;

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];

  get tahunOptions(): number[] {
    const kini = moment().year();
    const list: number[] = [];
    for (let t = kini; t >= kini - 5; t--) list.push(t);
    return list;
  }

  get hariList(): number[] {
    if (!this.data) return [];
    const list: number[] = [];
    for (let h = 1; h <= this.data.periode.jumlah_hari; h++) list.push(h);
    return list;
  }

  get grandTotal(): number {
    if (!this.data) return 0;
    return this.hariList.reduce((t, h) => t + this.totalHari(h), 0);
  }

  mounted(): void {
    this.muat();
  }

  async muat(): Promise<void> {
    this.loading = true;
    try {
      const res = await LaporanKegiatanIgd.get({
        tahun: this.tahun,
        bulan: this.bulan
      });
      this.data = res;
      this.draft = { ...res.koreksi };
      this.catatan = res.catatan;
      this.berubah = false;
    } catch {
      this.data = null;
    } finally {
      this.loading = false;
    }
  }

  async simpan(): Promise<void> {
    if (!this.data) return;
    this.saving = true;
    try {
      const res = await LaporanKegiatanIgd.save(
        { tahun: this.tahun, bulan: this.bulan },
        this.draft,
        this.catatan
      );
      this.data = res;
      this.draft = { ...res.koreksi };
      this.catatan = res.catatan;
      this.berubah = false;
    } catch {
      // pesan sudah ditampilkan ErrorAlert
    } finally {
      this.saving = false;
    }
  }

  async cetak(): Promise<void> {
    this.printing = true;
    try {
      await LaporanKegiatanIgd.openPdf({
        tahun: this.tahun,
        bulan: this.bulan
      });
    } catch {
      // pesan sudah ditampilkan ErrorAlert
    } finally {
      this.printing = false;
    }
  }

  isManual(dKey: string): boolean {
    return !!this.data && this.data.disposisi_manual.indexOf(dKey) >= 0;
  }

  nilaiRme(kKey: string, dKey: string, hari: number): number {
    if (!this.data) return 0;
    return this.data.rme[selKey(kKey, dKey, hari)] || 0;
  }

  nilai(kKey: string, dKey: string, hari: number): number {
    const key = selKey(kKey, dKey, hari);
    if (Object.prototype.hasOwnProperty.call(this.draft, key)) {
      return this.draft[key];
    }
    return this.nilaiRme(kKey, dKey, hari);
  }

  tampil(kKey: string, dKey: string, hari: number): string {
    const v = this.nilai(kKey, dKey, hari);
    return v > 0 ? String(v) : "";
  }

  dikoreksi(kKey: string, dKey: string, hari: number): boolean {
    const key = selKey(kKey, dKey, hari);
    return (
      Object.prototype.hasOwnProperty.call(this.draft, key) &&
      this.draft[key] !== this.nilaiRme(kKey, dKey, hari)
    );
  }

  selClass(kKey: string, dKey: string, hari: number): string {
    return this.dikoreksi(kKey, dKey, hari) ? "sel-koreksi" : "";
  }

  tooltipSel(kKey: string, dKey: string, hari: number): string {
    return this.dikoreksi(kKey, dKey, hari)
      ? `Dikoreksi manual — hitungan RME: ${this.nilaiRme(kKey, dKey, hari)}`
      : "Angka dari data RME";
  }

  ubah(kKey: string, dKey: string, hari: number, ev: Event): void {
    const el = ev.target as HTMLInputElement;
    const bersih = el.value.replace(/[^0-9]/g, "");
    if (bersih !== el.value) el.value = bersih;

    const key = selKey(kKey, dKey, hari);
    const angka = bersih === "" ? 0 : parseInt(bersih, 10);

    if (angka === this.nilaiRme(kKey, dKey, hari)) {
      this.$delete(this.draft, key);
    } else {
      this.$set(this.draft, key, angka);
    }

    this.berubah = true;
  }

  jumlahBaris(kKey: string, dKey: string): number {
    return this.hariList.reduce((t, h) => t + this.nilai(kKey, dKey, h), 0);
  }

  totalHari(hari: number): number {
    const d = this.data;
    if (!d) return 0;
    let t = 0;
    Object.keys(d.kategori).forEach(kKey => {
      Object.keys(d.disposisi).forEach(dKey => {
        t += this.nilai(kKey, dKey, hari);
      });
    });
    return t;
  }
}
